import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default () => {
  const mobileHeaders = document.querySelectorAll('.js-mobile-header')
  if ( mobileHeaders.length < 1) return

  ;[...mobileHeaders].forEach(header => {
    const buttons = header.querySelectorAll('.js-toggle-mobile-search')
    const wrapper = header.querySelector('.js-mobile-search')
    const container = header.querySelector('.js-mobile-header-container')
  
    if ( buttons.length < 1 || ! wrapper) return
  
    ;[...buttons].forEach(button => {
      button.addEventListener('click', e => {
        wrapper.classList.toggle('active')
        container.classList.toggle('active')

        // If active, disable scrolling for everything but wrapper
        if ( wrapper.classList.contains('active') ) {
          disableBodyScroll(wrapper)
        } else {
          enableBodyScroll(wrapper)
        }
      })
    })

    // Close if click outside
    wrapper.addEventListener('click', e => {

      if (! e.target.closest('.js-mobile-search-field')) {
        wrapper.classList.remove('active')
        container.classList.remove('active')
        enableBodyScroll(wrapper)
      }
    })

  })

}


// WEBPACK FOOTER //
// ./src/js/modules/SearchMobile.js